import React from "react";
import { useForm } from "react-hook-form";
import { Box, Grid, Typography, Button, Paper } from "@mui/material";
import RFG from "../../libs/inputs/RFG";

export default function Form({
  title,
  companies = [],
  projects = [],
  users = [],
  defaultValues = {},
  onSubmit = () => { },
  onChange = () => { },
}) {
  const { handleSubmit, control } = useForm({ defaultValues, mode: "all" });

  return (
    <Box sx={{ p: 1 }}>
      <form
        onSubmit={handleSubmit((data) => {
          console.log("data submit", data);
          onSubmit(data);
        })}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <RFG
              name="brand_name"
              label="Brand Name"
              control={control}
              rules={{
                required: true,
                maxLength: 500,
                pattern: {
                  value: /^[A-Za-z0-9\s\-_.]+$/,
                  message: "Invalid brand name. Allowed: letters, numbers, spaces, - _ .",}
              }}
            >
              <input autoComplete="off" />
            </RFG>
          </Grid>
        </Grid>

        <Box mt={3} display="flex" justifyContent="flex-end">
          <Button type="submit" className="btn-primary" color="primary">
            Save
          </Button>
        </Box>
      </form>
    </Box>

  );
}
